const MVCObject = require("../mvcobject").MVCObject;
const TemplateRenderer = require("../templaterenderer").TemplateRenderer;
const $ = require("../jquery_with_plugins");

/**
 * Take the template of travelModePanel to generate an object
 * @constructor
 * @param {string} travelModeSelectionPanelTemplate template of the travel mode pane
 * @extends woosmap.utils.MVCObject
 * @memberOf woosmap.ui
 */
const TravelModeSelector = function (travelModeSelectionPanelTemplate) {
    this._renderer = new TemplateRenderer(travelModeSelectionPanelTemplate);
    this.$travelModeSelectionPanel = $("<div>");
    this.$travelModeSelectionPanel.append($(this._renderer.render()));
    this.selectedTravelMode = this.$travelModeSelectionPanel.find(".woosmap-travel-mode-option").data("travel-mode");
    this.initializedTravelModeChoice();
};

TravelModeSelector.prototype = new MVCObject();

/**
 * Initialized comportement of travel mode panel's objects
 */
TravelModeSelector.prototype.initializedTravelModeChoice = function () {
    const self = this;
    this.$travelModeSelectionPanel.find(".woosmap-travel-mode-option").click(function () {
        const travelModeValue = $(this).data("travel-mode");
        if ((typeof google !== "undefined" && google.maps.TravelMode[travelModeValue]) || typeof BMap !== "undefined") {
            self.set("selectedTravelMode", travelModeValue);
        } else if (!(typeof console === "undefined" || typeof console.error === "undefined")) {
            console.error(travelModeValue, "not allowed");
        }
    });
};

/**
 * Return the container instantiated with travel mode panel
 */
TravelModeSelector.prototype.getSelectorContainer = function () {
    return this.$travelModeSelectionPanel;
};

exports.TravelModeSelector = TravelModeSelector;
